import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Type } from '@angular/core';

export interface ISnCanDisable {
  disabled: boolean;
}

export function mixinDisable<T extends Type<any>>(base: T): Type<ISnCanDisable> & T {
  return class extends base {
    private _disabled = false;

    constructor(...args: any[]) {
      super(...args);
    }

    get disabled(): boolean {
      return this._disabled;
    }
    set disabled(value: boolean) {
      this._disabled = coerceBooleanProperty(value);
    }
  };
}
